import { ReviewCard } from "./ReviewCard";
import type { ReviewCardProps } from "./ReviewCard.d";

export { ReviewCardProps };
export { ReviewCard };
